import React from "react";
import {
    DataGrid,
    GridActionsCellItem,
    GridColDef,
    GridEventListener,
    GridRowEditStopReasons, GridRowId, GridRowModel, GridRowModes,
    GridRowModesModel
} from "@mui/x-data-grid";
import {Link} from "react-router-dom";
import {
    Cancel,
    CancelRounded,
    CheckBoxRounded, Delete,
    DirectionsCar, Edit,
    Event,
    HelpOutlined,
    LocalDining, People, Save
} from "@mui/icons-material";
import {QuickFilterToolBar} from "../CheckIn";
import {Payment} from "../Payments";


const checkerBoxer = (params: any) => {
    if (params.value == null) {
        return <HelpOutlined htmlColor={"yellow"}/>
    }
    if (params.value) {
        return <CheckBoxRounded htmlColor={"green"}/>
    } else {
        return <CancelRounded htmlColor={"red"}/>
    }

}

export default function PaymentsDataGrid(params: {payments: any[], paidParking: boolean, onEdit: (row: any) => void}) {
    const [rows, setRows] = React.useState(params.payments);
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const handleRowEditStop: GridEventListener<'rowEditStop'> = (eParams, event) => {
        if (eParams.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
        /*console.log(eParams)
        console.log()
        console.log(rows.find((row) => row.id === eParams.id))
        *///params.onEdit()
    };

    const handleEditClick = (id: GridRowId) => () => {
        setRowModesModel({...rowModesModel, [id]: {mode: GridRowModes.Edit}});
    };

    const handleSaveClick = (id: GridRowId) => () => {
        setRowModesModel({...rowModesModel, [id]: {mode: GridRowModes.View}});

    };

    const handleCancelClick = (id: GridRowId) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: {mode: GridRowModes.View, ignoreModifications: true},
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow!.isNew) {
            setRows(rows.filter((row) => row.id !== id));
        }
    };

    const processRowUpdate = (newRow: GridRowModel) => {
        const updatedRow = {...newRow};
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        updatedRow.event = (updatedRow.event == null) ? false : updatedRow.event
        updatedRow.parking = (updatedRow.parking == null) ? false : updatedRow.parking
        updatedRow.meal = (updatedRow.meal == null) ? false : updatedRow.meal
        updatedRow.secondary = (updatedRow.secondary == null) ? false : updatedRow.secondary

        params.onEdit(updatedRow)
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };


    const columns: GridColDef[] = [
        {
            field: 'characterName', headerName: 'Character'
        },
        {
            field: 'playerName', headerName: 'Player',
        },
        {
            field: 'event', headerName: 'Event', align: "center", headerAlign: "center",
            renderCell: checkerBoxer,
            renderHeader: () => (<Event/>),
            width: 70,
            editable: true,
            type: 'boolean',
            hideSortIcons: true
        },
        ...(params.paidParking ? [{
            field: 'parking', headerName: 'Park', align: "center" as const, headerAlign: "center" as const,
            renderCell: checkerBoxer,
            renderHeader: () => (<DirectionsCar/>),
            width: 70,
            editable: true,
            type: 'boolean' as const,
            hideSortIcons: true
        }] : []),
        {
            field: 'meal', headerName: 'Meal', align: "center", headerAlign: "center",
            renderCell: checkerBoxer,
            renderHeader: () => (<LocalDining/>),
            width: 70,
            editable: true,
            type: 'boolean',
            hideSortIcons: true
        },
        {
            field: 'secondary', headerName: 'Second', align: "center", headerAlign: "center",
            renderCell: checkerBoxer,
            renderHeader: () => (<People/>),
            width: 70,
            editable: true,
            type: 'boolean',
            hideSortIcons: true
        }, {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({id}) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<Save/>}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<Cancel/>}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<Edit/>}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                    />
                ];
            }
        }
    ]

    return (
        <React.Fragment>
            <h2>Payments</h2>
            <DataGrid slots={{toolbar: QuickFilterToolBar}}
                      editMode="row"
                      rowModesModel={rowModesModel}
                      onRowModesModelChange={handleRowModesModelChange}
                      onRowEditStop={handleRowEditStop}
                      processRowUpdate={processRowUpdate}
                      autoHeight={true}
                      disableColumnMenu={true}
                      rows={rows}
                      columns={columns}
                      getRowId={(row) => row.id}
                      disableRowSelectionOnClick
                      density={"compact"}

            />
        </React.Fragment>
    )
}